import { Cidade, Doenca, Pessoa, PessoaEndereco, PessoaFisica } from "@tivic-team/manager-ts/dist/grl";
import { DocumentoTramitacao } from "@tivic-team/manager-ts/dist/ptc/entities/documento-tramitacao.entity";
import { DocumentoOcorrencia } from "@tivic-team/manager-ts/dist/ptc/entities/documento-ocorrencia.entity";
import { Documento } from "@tivic-team/manager-ts/dist/ptc/entities/documento.entity";
import { CartaoDocumento } from "@tivic-team/manager-ts/dist/mob/entities/cartao-documento.entity";
import { SituacaoDocumento } from "@tivic-team/manager-ts/dist/ptc/entities/situacao-documento.entity";
import { Cartao } from "@tivic-team/manager-ts/dist/mob/entities/cartao.entity";
import { AgendaItem } from "@tivic-team/manager-ts/dist/agd/entities/agenda-item.entity";
import { PessoaFichaMedica } from "@tivic-team/manager-ts/dist/grl/entities/pessoa-ficha-medica.entity";
import { CartaoDocumentoDoenca } from "@tivic-team/manager-ts/dist/mob/entities/cartao-documento-doenca.entity";

export class CartaoDocumentoDTO {
    cartaoDocumento: CartaoDocumento = void(0);
    cartaoDocumentoDoenca: Array<CartaoDocumentoDoenca> = void(0);
    documento: Documento = void(0);
    pessoa: Pessoa = void(0);
    pessoaFisica: PessoaFisica = void(0);
    pessoaEndereco: PessoaEndereco = void(0);
    cartao: Cartao = void(0);
    agendaItem: AgendaItem = void(0);
    cidade: Cidade = void(0);
    pessoaFichaMedica: PessoaFichaMedica = void(0);
    documentoTramitacao: DocumentoTramitacao = void(0);
    documentoOcorrencia: DocumentoOcorrencia = void(0);
    situacaoDocumento: SituacaoDocumento = void(0);
    doencas: Array<Doenca> = void(0);
}

export class CartaoDocumentoListDTO {
    items: Array<CartaoDocumentoDTO>;
    total: number;

    constructor() {}
}